import moment, { Moment } from 'moment/moment'

export interface AppContentPayload {
    id: number
    type: string
    name: string
    section_id: number
    section_name: string
    tags: string[]
    published: boolean
    created_at: string
}

export class AppContent {

    id: number
    type: string
    name: string
    sectionId: number
    sectionName: string
    tags: string[]
    published: boolean
    createdAt: string

    constructor(data: AppContentPayload) {
        this.id = data.id
        this.type = data.type
        this.name = data.name
        this.sectionId = data.section_id
        this.sectionName = data.section_name
        this.tags = data.tags
        this.published = !! data.published
        this.createdAt = moment(data.created_at)
        this.capture(data)
    }

    fill(data: AppContentPayload): this {
        this.id = data.id
        this.type = data.type
        this.name = data.name
        this.sectionId = data.section_id
        this.sectionName = data.section_name
        this.tags = data.tags
        this.published = !! data.published
        this.createdAt = moment(data.created_at)
        this.capture(data)
        return this
    }

    capture(data: AppContentPayload): this {
        return this
    }

    exists(): boolean {
        return !! this.id
    }

    unset(): void {
        this.fill(<any>{})
    }

    payload(): AppContentPayload {
        return {
            id: this.id,
            type: this.type,
            name: this.name,
            section_id: this.sectionId,
            section_name: this.sectionName,
            tags: this.tags,
            published: this.published
        }
    }
}
